import type {
	Basket,
	BasketItem
} from "@nwt/norce-pwa/dist/runtime/types/api/shopping/basket";
import { isShippingItem } from "./isShippingItem";
import { isDepositItem, type DepositConfig } from "./deposit";

/*
	Products with ParentLineNo is part of a bundle, an attached item from promotion or such.
	We want to remove these and shipping-only items from the basket when displaying it in the cart, to
	prevent confusion for the user.

	Deposit child lines are the exception: they stay in basket.Items so the
	deposit summary row can sum them — the cart UI
	hides them at render time instead (SharedBasket / LayoutSideCart /
	SharedProductOrderItem).
*/
/**
 * A child line whose parent is in the same basket — a bundle's contents, a
 * promotion's attached item. Shared by the filter and the cart row so both hide
 * the same lines: an *orphaned* child keeps its row on purpose, or it would
 * count towards the total with nothing on screen to explain it.
 *
 * `ParentLineNo: 0` means line 0, not "no parent" — moot while Norce numbers
 * from 1, and the lookup rejects it anyway.
 */
export const isAttachedChildLine = (
	item: Partial<BasketItem> | undefined,
	items: BasketItem[] | undefined | null
): boolean =>
	item?.ParentLineNo != null &&
	(items ?? []).some((line) => line.LineNo === item.ParentLineNo);

export const filterBasketItemsForDisplay = (
	basket: Basket | undefined,
	depositConfig?: DepositConfig
) => {
	if (!basket?.Items) {
		return basket;
	}

	const items = basket.Items;

	return {
		...basket,
		Items: items.filter(
			(item) =>
				isDepositItem(item, depositConfig) ||
				(!isAttachedChildLine(item, items) && !isShippingItem(item))
		)
	};
};
